// eslint-disable-next-line no-shadow
var IoTDeviceDirection;
(function (IoTDeviceDirection) {
    IoTDeviceDirection["IN"] = "IN";
    IoTDeviceDirection["OUT"] = "OUT";
    IoTDeviceDirection["BOTH"] = "BOTH";
})(IoTDeviceDirection || (IoTDeviceDirection = {}));

export { IoTDeviceDirection };
//# sourceMappingURL=ioTDeviceDirection.js.map
